import qs from 'qs'
import { request } from '@/utils/request'
const loginHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
}
export function login(data) {
    return request({
        url: '/a/login?__ajax',
        method: 'post',
        data: qs.stringify(data),
        headers: loginHeaders
    });
}

export function logout(data) {
    return request({
        url: `/a/logout;JSESSIONID=${data}?__ajax`,
        method: 'get',
    });
}



